document.addEventListener('DOMContentLoaded', function() {
  const loaderOverlay = document.querySelector('.loader-overlay');

  function debugLog(step, data) {
    console.log(`Debug [${step}]:`, data);
  }

  function showLoader() {
    loaderOverlay.style.display = 'flex';
  }

  function hideLoader() {
    loaderOverlay.style.display = 'none';
  }

  async function findCartItem(cart, searchKey) {
    // Extract the variant ID from the key (everything before the colon)
    const searchVariantId = searchKey.split(':')[0];
    
    const item = cart.items.find(item => 
      // Match by variant ID
      item.variant_id.toString() === searchVariantId ||
      // Or by exact key
      item.key === searchKey
    );

    debugLog('findCartItem', {
      searchKey,
      searchVariantId,
      found: !!item,
      item
    });

    return item;
  }
  async function updateCart(key, quantity) {
    debugLog('updateCart start', { key, quantity });
    showLoader();
    
    try {
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        debugLog('cart fetched', cart);

        let itemToChange = await findCartItem(cart, key);
        
        if (!itemToChange) {
            debugLog('item not found', { searchKey: key });
            hideLoader();
            return;
        }

        debugLog('item found', itemToChange);

        if (quantity === 0) {
          // If this is a parent item being removed, remove its services first
          if (itemToChange.properties?.Variant) {
              const services = cart.items.filter(item => 
                  item.properties?.Parent === itemToChange.properties.Variant
              );
              
              debugLog('removing services first', services);
              
              for (const service of services) {
                  try {
                      const response = await fetch('/cart/change.js', {
                          method: 'POST',
                          headers: {
                              'Content-Type': 'application/json',
                          },
                          body: JSON.stringify({
                              id: service.key,
                              quantity: 0
                          })
                      });
                      
                      if (!response.ok) {
                          throw new Error(`Remove service failed: ${response.status}`);
                      }
                      
                      debugLog('service removed', await response.json());
                  } catch (error) {
                      debugLog('error removing service', error);
                  }
              }
      
              // New code to refresh cart state after service removal
              debugLog('fetching updated cart state', { key });
              const updatedCartResponse = await fetch('/cart.js');
              const updatedCart = await updatedCartResponse.json();
              const updatedItem = await findCartItem(updatedCart, key);
              
              if (updatedItem) {
                  itemToChange = updatedItem; // Update the reference to use current cart state
                  debugLog('updated item reference', updatedItem);
              } else {
                  debugLog('item not found after service removal', { searchKey: key });
                  hideLoader();
                  return;
              }
          }
      
          // Remove the target item - don't check for parent removal anymore
          const response = await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                  id: itemToChange.key,
                  quantity: 0
              })
          });
      
          if (!response.ok) {
              throw new Error(`Remove failed: ${response.status}`);
          }
      
          debugLog('removal complete', await response.json());
      } else {
          // Handle quantity updates
          const response = await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                  id: itemToChange.key,
                  quantity: quantity,
                  properties: itemToChange.properties || {}
              })
          });
      
          if (!response.ok) {
              throw new Error(`Update failed: ${response.status}`);
          }
          
          debugLog('quantity update complete', await response.json());
      }
      
      setTimeout(() => location.reload(), 500);
      } catch (error) {
          debugLog('updateCart error', error.message);
          console.error('Error:', error);
          hideLoader();
          alert('There was an error updating the cart. Please try again.');
      }
  }
  async function addService(variantId, properties) {
    debugLog('addService start', { variantId, properties });
    showLoader();
    
    try {
      // Preserve all existing properties
      let serviceProperties = {
        ...properties  // Spread existing properties first
      };
  
      // Find the service row to check if it's a warranty service
      const serviceRow = document.querySelector(
        `.cart-item-service [data-service-id="${variantId}"]`
      )?.closest('.cart-item-service');
  
      // Check if this is a monthly insurance service and add fixed price
      const serviceButton = document.querySelector(`[data-service-id="${variantId}"]`);
      const serviceContainer = serviceButton?.closest('.cart-item-service');
      const serviceTitle = serviceContainer?.querySelector('.base-text')?.textContent;
      
      console.log('=== WARRANTY DEBUG ===');
      console.log('Service Container:', serviceContainer);
      console.log('Service Title:', serviceTitle);
      console.log('Variant ID:', variantId);
      
      // Check if this is a monthly insurance service by checking if title contains insurance keywords
      const isMonthlyInsurance = serviceTitle && (
        serviceTitle.toLowerCase().includes('monthly insurance') || 
        serviceTitle.toLowerCase().includes('protect') ||
        serviceTitle.toLowerCase().includes('warranty') ||
        serviceTitle.toLowerCase().includes('care')
      );
      
      console.log('Is Monthly Insurance:', isMonthlyInsurance);
      
      if (isMonthlyInsurance) {
        serviceProperties = {
          ...serviceProperties,  // Keep existing properties
          'Monthly price': '£4.99 per month'
        };
        console.log('Added fixed monthly insurance price:', serviceProperties);
      }
  
      console.log('=== SENDING TO CART ===');
      console.log('Variant ID:', variantId);
      console.log('Properties being sent:', serviceProperties);
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: serviceProperties  // Use our new properties object
        })
      });
  
      if (!response.ok) {
        throw new Error(`Add service failed: ${response.status}`);
      }
  
      debugLog('addService success', await response.json());
      setTimeout(() => location.reload(), 500);
    } catch (error) {
      debugLog('addService error', error.message);
      console.error('Error:', error);
      hideLoader();
    }
  }

  // Event delegation for all cart actions
  document.querySelector('.cart-items-container').addEventListener('click', function(event) {
    const removeButton = event.target.closest('.remove-item');
    if (removeButton) {
      event.preventDefault();
      const key = removeButton.getAttribute('data-key');
      debugLog('remove clicked', { key });
      
      if (!key) {
        debugLog('error', 'No key found on remove button');
        return;
      }
      
      removeButton.disabled = true;
      removeButton.style.opacity = '0.5';
      updateCart(key, 0);
    }

    const addServiceButton = event.target.closest('.add-service');
    if (addServiceButton) {
      event.preventDefault();
      const serviceId = addServiceButton.getAttribute('data-service-id');
      const parentId = addServiceButton.getAttribute('data-parent-id');
      debugLog('add service clicked', { serviceId, parentId });
      
      if (!serviceId || !parentId) {
        debugLog('error', 'Missing service or parent ID');
        return;
      }
      
      addServiceButton.disabled = true;
      addServiceButton.style.opacity = '0.5';
      addService(serviceId, { Parent: parentId });
    }
  });

  // Handle quantity changes
  document.querySelector('.cart-items-container').addEventListener('change', function(event) {
    const quantitySelect = event.target.closest('.quantity-select');
    if (quantitySelect) {
      const key = quantitySelect.getAttribute('data-key');
      const quantity = parseInt(quantitySelect.value, 10);
      
      if (key && !isNaN(quantity)) {
        updateCart(key, quantity);
      }
    }
  });

  // Handle checkout
  const checkoutForm = document.getElementById('cart-checkout-form');
  if (checkoutForm) {
    checkoutForm.addEventListener('submit', function(event) {
      showLoader();
    });
  }


  hideLoader();
});

